import { Injectable, computed, signal } from '@angular/core';

export interface InternalDragSource {
    panelId: string;
    path: string;
}

@Injectable({
    providedIn: 'root'
})
export class UiStateService {
    documentMatrixVisible = signal(true);

    dragSource = signal<InternalDragSource | null>(null);
    readonly isInternalDragging = computed(() => this.dragSource() !== null);

    toggleDocumentMatrix() {
        this.documentMatrixVisible.set(!this.documentMatrixVisible());
    }

    setDocumentMatrixVisible(visible: boolean) {
        this.documentMatrixVisible.set(visible);
    }
}
